import { Card as MuiCard, styled } from '@mui/material';

const Card = styled(MuiCard)(({ theme }) => ({
  maxWidth: 556,
  margin: '0 auto',
  borderRadius: 12,
  padding: '30px 40px',
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
}));

export default Card;
